export default __webpack_public_path__ + "b83378645a21947c287de48f01a27033.png";